export default __webpack_public_path__ + "static/media/P1.b0234b6d.svg";